module.exports = __webpack_public_path__ + "static/media/document.b7efc27d.png";